import { AppBar, Avatar, Box, createStyles, IconButton, LinearProgress, makeStyles, Menu, Theme, Toolbar } from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';
import React, { FC, useState } from 'react';
import { Link } from 'react-router-dom';

import SettingsMenu from './SettingsMenu';
import { Person } from '../gql-types.generated';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    grow: {
      flexGrow: 1,
    },
    appBar: {
      boxShadow: '0px 3px 6px #00000012',
    },
    settingsBox: {
      width: 400,
    },
    home: {
      marginRight: theme.spacing(2),
      border: '1px solid #00000012',
      padding: theme.spacing(1),
      borderRadius: 10,
    },
    text: {
      fontWeight: 'bold',
    },
    logo: {
      height: '27px',
      marginLeft: theme.spacing(0),
      marginTop: '10px',
    },
    linearProgress: {
      marginTop: -4,
    },
  }),
);

interface AppBarProps {
  isOnboarded: boolean;
  networkBusy: boolean;
  viewerUser?: Person | undefined;
}
const PrimaryAppBar: FC<AppBarProps> = props => {
  const { isOnboarded, networkBusy, viewerUser } = props;
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState<Element | null>();

  const handleClick = (event: { currentTarget: Element }) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  let initials = <PersonIcon />;
  if (viewerUser) {
    let userInitials = viewerUser.firstName ? viewerUser.firstName[0] : '';
    userInitials += viewerUser.lastName ? viewerUser.lastName[0] : '';

    initials = <span>{userInitials}</span>;
  }

  return (
    <div className={classes.grow}>
      <AppBar position="static" color="inherit" className={classes.appBar}>
        <Toolbar>
          <Link to="/">
            <img className={classes.logo} src="logo.png" alt="ApteanPay Logo" />
          </Link>

          <div className={classes.grow} />
          <IconButton onClick={handleClick} title="User Settings" data-cy="user-settings">
            <Avatar data-cy="user-avatar">{initials}</Avatar>
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            id="menu-appbar"
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            MenuListProps={{ disablePadding: true }}
          >
            <Box className={classes.settingsBox}>
              <SettingsMenu isOnboarded={isOnboarded} afterClick={handleClose} />
            </Box>
          </Menu>
        </Toolbar>
        {networkBusy && <LinearProgress className={classes.linearProgress} color="primary" />}
      </AppBar>
    </div>
  );
};

export default PrimaryAppBar;
